export const normalizeMenuPath = (path: string | null | undefined): string => {
  const raw = String(path ?? '').trim()
  if (!raw) return ''
  const withoutQuery = raw.split('?')[0].split('#')[0]
  if (withoutQuery.length > 1 && withoutQuery.endsWith('/')) {
    return withoutQuery.slice(0, -1)
  }
  return withoutQuery
}

export const menuPathsMatch = (a: string | null | undefined, b: string | null | undefined): boolean => {
  const left = normalizeMenuPath(a)
  const right = normalizeMenuPath(b)
  if (!left || !right) return false
  return left === right
}

export const menuPathInList = (path: string | null | undefined, paths: readonly string[]): boolean => {
  const target = normalizeMenuPath(path)
  if (!target) return false
  return paths.some((item) => menuPathsMatch(target, item))
}
